import { IUnidadeSaudePagedResponse } from "models/response/unidade-saude-paged-response";

export interface UnidadeSaudeDetailsState {
    unidadeSaudeDetails: IUnidadeSaudePagedResponse | null;
    loading: boolean;
    error: string | null;
}

export const ACTION_TYPES = {
    setUnidadeSaudeDetails: 'setUnidadeSaudeDetails',
    setLoading: 'setLoading',
    setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface UnidadeSaudeDetailsAction {
    type: ActionType;
    payload: any;
}

export const UnidadeSaudeDetailsReducer = (
    state: UnidadeSaudeDetailsState,
    action: UnidadeSaudeDetailsAction
): UnidadeSaudeDetailsState => {
    switch (action.type) {
        case ACTION_TYPES.setUnidadeSaudeDetails:
            return { ...state, unidadeSaudeDetails: action.payload, error: null };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: action.payload };
        case ACTION_TYPES.setError:
            return { ...state, error: action.payload, loading: false };
        default:
            return state;
    }
};
